<template>
  <div class="module-item p-2">
    <div class="module-title mb-2">
      <div class="input-group">
        <input v-model="data.name" class="form-control" />
        <span class="input-group-append">
          <button class="btn btn-success rounded-0" @click="save">Salvar</button>
        </span>
        <span class="input-group-append">
          <button class="btn btn-danger rounded-0" @click="del">Deletar</button>
        </span>
      </div>
    </div>

    <div
      class="w-100 bg-dark text-center text-white clickable"
      @click="toggle"
    >
      <span class="badge badge-danger"><b>{{ showing ? '--':'+'}}</b></span> {{ showing ? 'Esconder':'Ver'}} aulas
    </div>

    <div class="collapse" :id="`collapse-module-${moduleId}`">
      <classes-list v-for="item,i in classes" :key="i" :data="item" :course="course" :module="data.id" :index="i" @delete="deleteItem" />
      <button v-if="data.id" class="btn btn-sm btn-dark form-control" @click.prevent="addClasse"><i class="fa fa-plus-circle"></i>Adicionar Aula</button>
    </div>
  </div>
</template>

<script>
import Classes from './Classe'
import { Form } from 'vform'
import Axios from 'axios'

export default {
  props: {
    data: {
      required: true
    },
    course: {
      required: true
    },
    index: {
      required: true
    }
  },
  components: {
    'classes-list': Classes
  },
  watch: {
    data: {
      immediate: true,
      handler ( val, old ) {
        if ( val != undefined && val != old ) {
          this.classes = val.classes
        }
      }
    }
  },
  data() {
    return {
      showing: false,
      moduleId: undefined,
      classes: [],
      form: new Form({
        id: undefined,
        course_id: undefined,
        name: '',
        description: ''
      })
    }
  },
  methods: {
    toggle: function () {
      this.showing = !this.showing
      $(`#collapse-module-${this.moduleId}`).collapse('toggle')
    },
    addClasse: function () {
      this.classes = [...this.classes, { name: 'Nova Aula' }]
    },
    del: function () {
      if ( this.data.id ) {
        Axios.delete('/teacher/course/module', {
          data: {
            module: this.data.id
          }
        })
      }
      this.$emit('delete', this.index)
    },
    save: function () {
      if ( this.data.id ) {
        this.form.id = this.data.id
      }
      this.form.course_id = this.course
      this.form.name = this.data.name

      this.form.post('/teacher/course/module')
        .then( res => {
          this.$set(this.data, 'id', res.data.id)
        })
        .catch( err => {
          console.error( err )
        })
    },
    deleteItem: function ( index ) {
      this.classes = this.classes.filter( ( item,i ) => {
        return i != index
      })
    }
  },
  mounted() {
    this.moduleId = Math.floor((Math.random() * 999) + 1) + Math.floor((Math.random() * 10) + 1)
  }
}
</script>

<style>

</style>
